import { Component, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth-service';
import { MatDrawer } from '@angular/material/sidenav';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-burger-menu',
  templateUrl: './burger-menu.component.html',
  styleUrls: ['./burger-menu.component.scss']
})
export class BurgerMenuComponent {
  showFiller = false;
  constructor(
    private _authService: AuthService
  ){

  }
  safire_role: string | undefined
  safire_user_uuid: string | undefined
  quadLink: string | undefined
  fullLink: string | undefined
  uamLink: string = 'https://cristlgov.com/'
  @ViewChild('drawer')
  public drawer?: MatDrawer
  public drawer2?: MatDrawer

  ngOnInit(){
    let role = this._authService.getUserDetails()
    this.safire_role = role.payload['custom:safire_role']?.toString()
    this.safire_user_uuid = role.payload.sub
    this.quadLink = "/quad/id/"+this.safire_user_uuid
    this.fullLink = "/full/id/"+this.safire_user_uuid
  }
  
  onMenuClicked(value:any) {
    this.drawer?.toggle()
  }

  closeDrawer(){
    this.drawer?.close()
  }

  goToUam(){
    // console.log(environment.uamUrl)
    document.location.href = environment.uamUrl
    
  }
}
